export default "__VITE_ASSET__gGpjp5jT__"